import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";
import { useReadComposition } from "./useReadComposition";
import { useCompositionsContext } from "../context/CompositionsContext";
import EncryptionContext from "config/context/encryptionContext";
import { useCompositionAdvancedOptionsContext } from "../context/CompositionAdvancedOptionsContext";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useUpdateRowsService = () => {
    const { encryption } = useContext(EncryptionContext);
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { readComposition } = useReadComposition();
    const { page, limit } = useCompositionAdvancedOptionsContext();
    const { selectedComposition } = useCompositionsContext();
    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const updateRows = async ({ permission, private_key, composition, rowsData }) => {
        setLoading(true);
        try {
            const scopeToUse = (selectedComposition?.selected_scope || selectedAccount || "");
            const res = await fetch(`${URL}/api/database/update`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                    scope: scopeToUse,
                    permission: permission,
                    private_key: private_key,
                    encryption: encryption || false,
                    encryption_key: "",
                    composition: composition,
                    data: rowsData
                }),
            });

            const data = await res.json();
            setResponse(data);
            if (data?.status) {
                readComposition({ composition: composition, offset: (page - 1) * limit });
            }
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    }

    const resetServerStatus = () => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }

    return {
        response,
        loading,
        error,
        updateRows,
        resetServerStatus
    }
}